import { repository, baseURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/enums/applicationType/findAll')
    return data
  },

  async findActual() {
    const { data } = await repository.get(baseURL + '/enums/applicationType/findActual')
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/enums/applicationType', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/enums/applicationType', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/enums/applicationType/' + id)
  }
}
